import filter from 'lodash.filter'
import find from 'lodash.find'

// initial state
const state = {
  banners: [
    {
      id: 'EASTER22',
      tagline: null,
      image: 'https://d2w46cz0afxd34.cloudfront.net/assets/banners/Unknown-22.jpeg',
      width: '870px',
      start_date: 1649951657, // Thu April 14 2022 16:55:00 GMT+0100
      end_date: 1650135257,
      show_when: [
        'EASTER22'
      ]
    },
    {
      id: 'BF2021',
      tagline: 'The Black Friday sale is on! Enter the coupon code BF2021 to get £30 off Deluxe and Super Deluxe bookings!',
      image: 'https://d2w46cz0afxd34.cloudfront.net/assets/banners/banner-blackfriday-900x200.jpeg',
      width: '870px',
      start_date: 1637236800, // Thu Nov 18 2021 12:00:00 GMT+0000
      end_date: 1637236800,
      hide_when: [
        'BFC2021'
      ]
    },
    {
      id: 'FREECLEAN',
      tagline: 'Book now to get our Deluxe Service for the price of a Regular – you’ll get a bicycle service AND your bike will receive a professional valet for FREE (saving you £30.00). Your bike will look and ride like new!',
      image: 'https://d2w46cz0afxd34.cloudfront.net/assets/banners/banner-freebikeclean-v2-900x200.png',
      width: '870px',
      start_date: 1638273600, // Tue Nov 30 2021, 12:00:00 GMT+0000
      end_date: 1643673600, // Tue Feb 01 2022 00:00:00 GMT+0000
      show_when: [
        'FREECLEAN'
      ]
    },
    {
      id: 'TPB1',
      tagline: 'Trustpilot Banner 1',
      width: '870px',
      start_date: 1637236800, // Thu Nov 18 2021 12:00:00 GMT+0000
      end_date: 3638287782, // Mon Apr 16 2085 19:29:42 GMT+0000
      hide_when: [ // Add any promos here you don't want to show alongside this banner
        'FREECLEAN',
        'BF2021',
        'BFC2021',
        'EASTER22'
      ]
    }
  ],
  promoToShow: null
}

// getters
const getters = {
  /* Return an array of all active promotions */
  activeBanners (state) {
    return filter(state.banners, (banner) => {
      return bannerIsActive(state, banner)
    }) || []
  },

  /* Check the validity of the promotion */
  promoIsActive: (state) => (id) => {
    return typeof find(state.banners, (banner) => {
      return (banner.id === id) && bannerIsActive(state, banner)
    }) !== 'undefined'
  }
}

const mutations = {
  setPromoToShow (state, id) {
    state.promoToShow = id
  }
}

function bannerIsActive (state, banner) {
  return banner.start_date && banner.end_date && (Date.now() > (banner.start_date * 1000)) && ((banner.end_date * 1000) > Date.now()) && (typeof banner.show_when === 'undefined' || (banner.show_when !== 'undefined' && banner.show_when.includes(state.promoToShow))) && !(typeof banner.hide_when !== 'undefined' && banner.hide_when.includes(state.promoToShow))
}

export default {
  state,
  getters,
  mutations
}
